/**
 * **SVG の加工（純粋関数だけ）**（`docs/design-system.md` §3.4 / D97）。
 *
 * ## なぜ `icons.ts` から切り出したか（M16）
 *
 * `icons.ts` は `node:fs` を**モジュールの先頭で** import している。
 * **ブラウザ側から 1 つでも関数を借りると `node:fs` がバンドルに混入する** —
 * `Icon` のコメントが「**この部品はファイルを読まない**」と書いているのは
 * その事故を避けるためであり、**加工関数の置き場所も同じ理由で分ける**。
 *
 * **加工の規則はここが唯一の真実**である。`icons.ts` は再エクスポートするだけで、
 * `apps/web/test/icons.test.ts` は従来どおり `icons.ts` 越しに当てられる。
 */

/** **`fill="#..."` を落とす**（`currentColor` を継がせる。§3.4 加工 1） */
export function stripBakedFill(svg: string): string {
  return svg.replace(/\s*fill="#[0-9a-fA-F]{3,8}"/g, '');
}

/**
 * **`clipPath` を外す**（§3.4 加工 2）。
 *
 * **`<g clip-path="...">` の包みと `<defs>` の定義を両方落とす** —
 * 片方だけ落とすと**参照先の無い `clip-path` が残り、
 * ブラウザによっては図形ごと消える**。
 */
export function stripClipPath(svg: string): string {
  return svg
    .replace(/<g\s+clip-path="url\(#[^)]*\)"\s*>/g, '')
    .replace(/<\/g>\s*(?=<defs>|<\/svg>)/g, '')
    .replace(/<defs>[\s\S]*?<\/defs>/g, '');
}

/** SVG の中身（`<svg>` タグの内側）だけを取り出す */
export function innerOf(svg: string): string {
  const m = /<svg[^>]*>([\s\S]*)<\/svg>/.exec(svg);
  return (m?.[1] ?? '').trim();
}

/** **原本 → `Icon` に渡せる形**（加工 1 + 2 + 中身の取り出し） */
export function prepareIcon(raw: string): string {
  return innerOf(stripClipPath(stripBakedFill(raw)));
}
